import styled from 'styled-components';
import { Typography } from '@material-ui/core';

const Text = styled(Typography)`
  margin: 0px;
`;

export default Text;
